export { default } from './faq';
